import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { TreeItem, TreeviewComponent, TreeviewI18n, TreeviewItem } from '@soy-andrey-semyonov/ngx-treeview';
import { Observable, Subscription } from 'rxjs';
import { SimpleDataTreeviewI18n } from 'src/app/forms/simple-datatree/simple-datatree-i18n';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ThemeService } from 'src/app/services/theme.service';

export class ItemCategory{
    text:string;
    value:string;
    children:ItemCategory[];
}

@Component({
    selector: 'tiktok-category',
    templateUrl: './tiktok-category.component.html',
    styleUrl: './tiktok-category.component.scss',
    standalone: false
})

export class TiktokCategoryComponent  implements OnInit, OnDestroy {
  codecompany: any;
  sub:Subscription;
  lista:TreeviewItem[];
  buttonList:ButtonList[] = [];
  sub1:Subscription;
  
  @ViewChild(TreeviewComponent, { static: false }) treeviewComponent: TreeviewComponent;
  
  config = {
    hasAllCheckBox: false,
    hasFilter: true,
    hasCollapseExpand: true,
    decoupleChildFromParent: true,
  }
  
  selectedId:any;

  constructor(private http:HTTPService, private uid:UserAuthenticationServices , private cd:ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data, public ThemeService:ThemeService,public dialogRef:MatDialogRef<any>, private spinner:NgxSpinnerService) { }


  onSelectedChange(evento){
  }

  onFilterChange(evento){

  }

  onClickLine(evento:TreeviewItem){
    if ( evento.value == 0){
      return;
    }
    if (evento.children!=null && evento.children.length>0 && evento.children[0].text == 'A Carregar'){
      let level = evento.parentCount;
      let id = evento.value;
      this.findCategories(level,id,evento);
    }
     else{
       if ( !evento.children ){
         this.dialogRef.close(evento.value);
       }
    }
    
  }


  okFunction(){
    this.dialogRef.close();
  }

  ngOnInit(): void {

    this.lista = [new TreeviewItem({text:"Categorias",value:0, checked: false,collapsed:true, children:[]})];
    let formControl = (this.data as UntypedFormGroup);
    this.codecompany = formControl.get('CODECOMPANY').value;
    
    
    if ( this.codecompany == null ){
        this.dialogRef.close();
        throw  Error("Selecionar a empresa para buscar categorias.");
    }
    
    this.buttonList.push({
      color:"warn",
      description:"Sair",
      action: ()=>{
          this.okFunction();
      }
    })

    this.findCategories(null);
    
  }

  findCategories(level?:number, id?:string, parentData?:TreeviewItem){
    
    this.spinner.show();
    let ob = {
      "expressao": "getRequestData(GetCategories,Product,{@PARAMETER},GET,null,{@HEADER},{@CODEMKTP})",
      "novo": true,
      "codecompany": this.codecompany,
      "codemktp": 148,
      "codecontract": 0,
      "values":[] 
    }

    let header = {
      key:'@HEADER',
      value:`x-tts-access-token: {@MKTPACTIVECOMPANIES.ACESSTOKEN};content-type: application/json`
    }

    let parameters = {
      key:'@PARAMETER',
      value: '?shop_cipher={@MKTPACTIVECOMPANIES.SIGNATUREMETHOD}&signTikTok({@CODECOMPANY},{@MKTPSERVICES.URL}?shop_cipher={@MKTPACTIVECOMPANIES.SIGNATUREMETHOD},null)'
    }

    let keepParam = {
              key:'keepParam',
              value: true
    }

    ob['values'].push(header);
    ob['values'].push(parameters);
    ob['values'].push(keepParam);

    this.sub = this.http.post(ob,'FormulaServices/test', true,true,false).subscribe(
      {
        next:(data)=>{
          this.transformData(data);
        },
        error:(error)=>{
          this.spinner.hide();
          throw error;
        },
        complete:()=>{
          this.spinner.hide();
        }
    })
  
  
  }


  transformData(data):void{

    this.lista = [new TreeviewItem({text:"Categorias",value:0, checked: false,collapsed:true, children: []})];
    if ( data != null && ObjectUtil.isNotEmpty(data['resultado'])){
      let resultado = JSON.parse(data['resultado']);
      let array:[] = resultado['data']['categories'];
    
      for ( var item of array.filter(i=>i['parent_id'] == 0 )){
        let id = item['id'];
        let local_name = item['local_name'];
        let parent_id = item['parent_id'];

        let dataItem:TreeviewItem = new TreeviewItem({text:id + ' - '+local_name, value:id,collapsed:true, checked:false });
        
        if ( this.lista[0].children == null ){
          this.lista[0].children = [dataItem];
        }else{
          this.lista[0].children.push(dataItem);      
        }
        
        
        this.findItem(array,parent_id,dataItem);
                
      }
    }
    
  }

  findItem(array:Object[],  category_id:string, lista:TreeviewItem):void{

      let newArray:Object[] = array.filter(data=> data['parent_id'] == category_id );
  
      for ( var item of newArray ){
          let new_category_id = item['id'];
          let parent_id = item['parent_id'];
          let local_name = item['local_name'];
          let dataItem:TreeviewItem = new TreeviewItem({text:new_category_id + ' - '+ local_name, value:new_category_id, collapsed:true, checked: false, children:[] });
          if ( lista.children == null ){
            lista.children = [ dataItem ];
          }else{
            lista.children.push(dataItem)
          }
          this.findItem(array,new_category_id,dataItem);
      }  
  }

  ngOnDestroy(){
    if ( this.sub!= null ){ this.sub.unsubscribe()};
    if ( this.sub1!= null ){ this.sub1.unsubscribe()};
  }

}
